export const INDUSTRIES = [
  { id: 0, name: 'Automobiles and Components' },
  { id: 1, name: 'Banks' },
  { id: 2, name: 'Capital Goods' },
  { id: 3, name: 'Commercial and Professional Services' },
  { id: 4, name: 'Consumer Durables and Apparel' },
  { id: 5, name: 'Consumer Services' },
  { id: 6, name: 'Diversified Financials' },
  { id: 7, name: 'Energy' },
  { id: 8, name: 'Food, Beverage, and Tobacco' },
  { id: 9, name: 'Food and Staples Retailing' },
  { id: 10, name: 'Health Care Equipment and Services' },
  { id: 11, name: 'Household and Personal Products' },
  { id: 12, name: 'Insurance' },
  { id: 13, name: 'Materials' },
  { id: 14, name: 'Media and Entertainment' },
  { id: 15, name: 'Pharmaceuticals, Biotechnology, and Life Sciences' },
  { id: 16, name: 'Real Estate' },
  { id: 17, name: 'Retailing' },
  { id: 18, name: 'Semiconductors and Semiconductor Equipment' },
  { id: 19, name: 'Software and Services' },
  { id: 20, name: 'Technology Hardware and Equipment' },
  { id: 21, name: 'Telecommunication Services' },
  { id: 22, name: 'Transportation' },
  { id: 23, name: 'Utilities' },
];

export const SOFT_SKILLS = [
  { id: 0, name: 'Communication skills' },
  { id: 1, name: 'Interpersonal skills' },
  { id: 2, name: 'Problem-solving skills' },
  { id: 3, name: 'Adaptability' },
  { id: 4, name: 'Time management' },
  { id: 5, name: 'Organization' },
  { id: 6, name: 'Leadership' },
  { id: 7, name: 'Attention to detail' },
  { id: 8, name: 'Creativity' },
  { id: 9, name: 'Positive attitude' },
  { id: 10, name: 'Emotional intelligence' },
  { id: 11, name: 'Teamwork' },
  { id: 12, name: 'Conflict resolution' },
  { id: 13, name: 'Active listening' },
  { id: 14, name: 'Customer service orientation' },
  { id: 15, name: 'Positive impact' },
  { id: 16, name: 'Flexibility' },
  { id: 17, name: 'Initiative' },
  { id: 18, name: 'Critical thinking' },
  { id: 19, name: 'Stress management' },
  { id: 20, name: 'Presentation skills' },
  { id: 21, name: 'Decision making' },
  { id: 22, name: 'Mentorship' },
  { id: 23, name: 'Negotiation skills' },
  { id: 24, name: 'Self-motivation' },
  { id: 25, name: 'Dependability' },
  { id: 26, name: 'Work ethic' },
  { id: 27, name: 'Patience' },
  { id: 28, name: 'Effective prioritization' },
  { id: 29, name: 'Good judgment' },
  { id: 30, name: 'Professionalism' },
  { id: 31, name: 'Empathy' },
  { id: 32, name: 'Cultural competence' },
  { id: 33, name: 'Collaboration' },
  { id: 34, name: 'Effective feedback' },
  { id: 35, name: 'Responsibility' },
  { id: 36, name: 'Goal-oriented mindset' },
  { id: 37, name: 'Strong work ethic' },
  { id: 38, name: 'Continuous learning' },
  { id: 39, name: 'Effective delegation' },
];

export const INTERESTS = [
  { id: 0, name: 'Technology' },
  { id: 1, name: 'Entrepreneurship' },
  { id: 2, name: 'Finance' },
  { id: 3, name: 'Marketing' },
  { id: 4, name: 'Art' },
  { id: 5, name: 'Design' },
  { id: 6, name: 'Photography' },
  { id: 7, name: 'Music' },
  { id: 8, name: 'Writing' },
  { id: 9, name: 'Sports' },
  { id: 10, name: 'Travel' },
  { id: 11, name: 'Food' },
  { id: 12, name: 'Fashion' },
  { id: 13, name: 'Environmental issues' },
  { id: 14, name: 'Health and wellness' },
  { id: 15, name: 'Volunteer work' },
  { id: 16, name: 'Personal development' },
  { id: 17, name: 'Social media' },
  { id: 18, name: 'Politics' },
  { id: 19, name: 'History' },
  { id: 20, name: 'Languages' },
  { id: 21, name: 'Gaming' },
  { id: 22, name: 'Film and television' },
  { id: 23, name: 'Nature and outdoor activities' },
  { id: 24, name: 'Architecture' },
  { id: 25, name: 'Automotive' },
  { id: 26, name: 'Real estate' },
  { id: 27, name: 'Education' },
  { id: 28, name: 'Cooking' },
  { id: 29, name: 'Pets' },
  { id: 30, name: 'Personal finance' },
  { id: 31, name: 'DIY and home improvement' },
  { id: 32, name: 'Gardening' },
  { id: 33, name: 'Personal fitness' },
  { id: 34, name: 'Crafts' },
  { id: 35, name: 'Green energy' },
  { id: 36, name: 'Event planning' },
  { id: 37, name: 'Travel planning' },
];
